module.exports = __webpack_public_path__ + "img/SH2D_30004.901b7820.png";